import React from "react";
import { PHONE_NUMBER, PHONE_TEL } from "@/mock";

export const Footer = () => {
    return (
        <footer className="border-t border-olive-100 bg-olive-50">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 grid md:grid-cols-3 gap-6">
                <div>
                    <div className="text-xl text-olive-950">Психолог</div>
                    <p className="mt-2 text-olive-900/70 text-sm">Конфиденциальность гарантирована.</p>
                </div>

                <div>
                    <div className="mt-2 text-sm text-olive-900/60">Телефон</div>
                    <a className="text-olive-900" href={PHONE_TEL}>{PHONE_NUMBER}</a>

                    <div className="mt-2 text-sm text-olive-900/60">Telegram</div>
                    <a className="text-olive-900 flex items-center gap-1" href="https://t.me/bondarevapro" target="_blank" rel="noopener noreferrer">
                        bondarevapro
                    </a>

                    <div className="mt-2 text-sm text-olive-900/60">Instagram</div>
                    <a className="text-olive-900 flex items-center gap-1" href="https://www.instagram.com/bondareva.pro/" target="_blank" rel="noopener noreferrer">
                        bondareva.pro
                    </a>

                    <div className="mt-2 text-sm text-olive-900/60">Почта</div>
                    <a className="text-olive-900" href="mailto:kotikvseti@gmail.com">kotikvseti@gmail.com</a>
                </div>

                <div className="text-sm text-olive-900/60">© {new Date().getFullYear()} — Частная практика</div>
            </div>
        </footer>
    );
};
